<template>
  <div class="">
    <div class="head-title">个人活码</div>
    <el-collapse style="margin-bottom: 2.0rem;">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、利用微炬云个人活码功能，可以直接将多个企业员工创建成带参数的活码进行推广，用户扫描活码后会随机分配活码下的企业微信号，实现为多个企业微信引流。
          </p>
          <p>
            2、客户扫码后无需验证即可自动成为好友、自动下发欢迎语，方便后期精准转化、定向运营。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <!-- <div class="nav">
        渠道活码功能是非常实用的功能，可以实现同一个二维码，扫码后添加不同的客服（销售）人员。如果同时在企业微信官方后台配置了欢迎语，<a
          href=""
          >查看教程</a
        >
      </div> -->
      <div class="">
        <!-- <div class="botm-nav">
          <span>渠道二维码</span>
        </div> -->
        <div class="navbar">
          <div class="nav-l">
            <el-button icon="el-icon-plus" type="primary" @click="add"
              >新建渠道二维码</el-button
            >
          </div>
          <div class="nav-r">
            <el-input
              clearable
              style="width: 35.0rem; "
              v-model="username"
              prefix-icon="el-icon-search"
              @change="getActiveCode"
              placeholder="请输入渠道名称搜索"
            >
            <el-button slot="append" type="primary" @click="getActiveCode"
              >查询</el-button
            >
            </el-input>
            
          </div>
        </div>
        <el-table
          :data="tableData.data"
          border
          v-loading="tableLoading"
          style="margin-top: 2.0rem"
          row-key="id"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <el-table-column
            prop="name"
            label="渠道名称"
            style="width: 12.5%;"
          ></el-table-column>
          <el-table-column prop="qr_code" label="生成的活码图片" style="width: 12.5%;">
            <template slot-scope="scope">
              <el-image
                style="width: 4.0rem; height: 4.0rem"
                :src="scope.row.qr_code"
                :preview-src-list="[scope.row.qr_code]"
                fit="scale-down"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="type_name"
            label="使用模式"
            style="width: 12.5%;"
          ></el-table-column>
          <el-table-column prop="user_name" label="使用人员" style="width: 12.5%;">
            <template slot-scope="scope">
              <el-tag
                size="mini"
                style="margin: .2rem"
                v-for="t in scope.row.user_array_name"
                :key="t"
                >{{ t }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column prop="tag_idArrayName" label="客户标签" style="width: 12.5%;">
            <template slot-scope="scope">
              <el-popover placement="left" trigger="hover">
                <template>
                  <div
                    class="set-popper"
                    v-html="scope.row.tag_idArrayName"
                  ></div>
                </template>
                <div slot="reference">
                  <el-tag v-if="
                      scope.row.tag_idArrayName[0] == '暂无' &&
                      scope.row.tag_idArrayName.length == 1
                    "
                    size="mini"
                    >{{ scope.row.tag_idArrayName[0] }}</el-tag>
                  <!-- <div
                    v-if="
                      scope.row.tag_idArrayName[0] == '暂无' &&
                      scope.row.tag_idArrayName.length == 1
                    "
                  >
                    {{ scope.row.tag_idArrayName[0] }}
                  </div> -->
                  <div v-else class="set-content">
                    <el-tag
                      size="mini"
                      style="margin: .2rem"
                      v-for="(i, index) in scope.row.tag_idArrayName"
                      :key="index"
                      >{{ i }}</el-tag
                    >
                  </div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            style="width: 12.5%;"
          ></el-table-column>
          <el-table-column
            prop="createtime"
            label="创建时间"
            style="width: 12.5%;"
          ></el-table-column>
          <el-table-column label="操作" fixed="right" width="270" >
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="cumpile(scope.row)">
                编辑
              </el-button>
              <el-button type="text" size="mini">
                <a
                  :href="`https://api.weijub.com/crm/ActiveCode/getImages?url=${scope.row.qr_code}&usertoken=${tooken.usertoken}`"
                  style="color: #317AF8"
                  :download="`${scope.row.user}的渠道活码`"
                  >下载</a
                >
              </el-button>
              <el-button
                type="text"
                size="mini"
                @click="setWelcome(scope.row)"
              >
                设置欢迎语
              </el-button>
              <el-button
                type="text"
                size="mini"
                @click="lookWelcome(scope.row)"
                v-if="scope.row.if_show == 1"
              >
                查看欢迎语
              </el-button>
              <el-button @click="dele(scope.row)" size="mini" style="color:#f00000;" type="text">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging">
          <pagination
            :total="tableData.total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            :page-sizes="[10,20,50,100]"
            @pagination="getActiveCode"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import pagination from "@/components/Pagination";
export default {
  components: {
    pagination,
  },
  data() {
    return {
      tooken: [],
      tableData: {
        total: 0,
        data: [],
      },
      username: "",
      page: "",
      listQuery: {
        page: 1,
        limit: 20,
      },
      tableLoading: true,
    };
  },
  computed: {},
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.getActiveCode();
  },
  methods: {
    url(row) {
      return;
    },
    download(item) {
      this.axios
        .post(
          "/crm/ActiveCode/getImages",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            url: item.qr_code,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {})
        .catch(function (err) {});
    },
    cumpile(data) {
      // console.log(data);
      this.$router.push({
        name: "activeCodeCumpile",
        query: {
          data: data,
        },
      });
    },
    setWelcome(data) {
      this.$router.push({
        name: "newCustomerWelcomeAdd",
        query: {
          state: data.state,
          user_name: data.user_name,
          userid: data.user,
        },
      });
    },
    lookWelcome(data) {
      this.$router.push({
        name: "newCustomerWelcome",
        query: {
          state: data.state,
        },
      });
    },
    getActiveCode() {
      this.axios
        .post(
          "/crm/ActiveCode/getActiveCode",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            name: this.username,
            page: this.listQuery.page,
            number_page:this.listQuery.limit
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableLoading = false;
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getActiveCode();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    add() {
      this.$router.push({
        name: "activeCodeADD",
        // query:{
        //     tableData: this.tableData
        // }
      });
    },
    dele(e) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/ActiveCode/delActiveCode",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                id: e.id,
                config_id: e.config_id,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.getActiveCode();
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.body {
  width: 100%;
  height: 100%;
}
.home {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}
.nav {
  width: 100%;
  height: 6.0rem;
  background-color: #ff9393;
  line-height: 6.0rem;
  padding-left: 3.0rem;
  border: .1rem solid #7d7d7d;
}
.nav a {
  color: blue;
}
.body-botm {
  background-color: #f8f8f8;
  width: 100%;
  height: 100%;
}
.botm-nav {
  height: 7.0rem;
  background-color: #dcdcdc;
  line-height: 7.0rem;
  padding-left: 3.0rem;
  color: #3088db;
}
.botm-nav span {
  padding-bottom: .4rem;
  border-bottom: .2rem solid #3088db;
}
.body-name {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: 0rem .1rem .6rem 0rem rgba(0, 0, 0, 0.2);
  box-shadow: 0rem .1rem .6rem 0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}
.name-bottom {
  height: 5.0rem;
  line-height: 5.0rem;
}
::v-deep .el-table thead {
  color: #ffffff;
}
.el-button--text{
  padding-right: 0rem !important;
    padding-left: 0rem !important;
    width: 10.0rem;
    margin-left: 0rem !important;
    text-align: left;}
</style>

